import "core-js/modules/es.function.name";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import PerformanceContext from './PerformanceContext';

var mark = function mark(name) {
  return window.performance && window.performance.mark(name);
};

var measure = function measure(_ref) {
  var name = _ref.name,
      start = _ref.start,
      end = _ref.end;

  if (window.performance) {
    window.performance.measure(name, start, end);
  }
};

var PerformanceProvider = function PerformanceProvider(_ref2) {
  var children = _ref2.children;
  var context = {
    mark: mark,
    measure: measure
  };
  return /*#__PURE__*/React.createElement(PerformanceContext.Provider, {
    value: context
  }, children);
};

export default PerformanceProvider;